import React from 'react';

import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon';
import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {PaymentLinkPromo} from '@/app/main/paymentLink/components/PaymentLinkPromo/PaymentLinkPromo';
import {PaymentLinkUtm} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import {COLORS} from '@/styles/colors';

export const PaymentLinkExpired = ({name}) => {
  const {t} = useTranslation();

  return (
    <>
      <PaymentLinkLogo />
      <Box className="payment-link-image-text-container">
        <Box className="payment-link-text-container">
          <FuseSvgIcon
            size={40}
            sx={{color: COLORS.CONTENT_WARNING}}>
            heroicons-solid:x-circle
          </FuseSvgIcon>
          <Typography className="payment-link-title payment-link-title--declined">
            {t('payment_link.link_already_used')}
          </Typography>
          <Typography className="payment-link-subtitle">
            {t('payment_link.ask_new_link', {
              name: name,
            })}
          </Typography>
        </Box>
      </Box>
      <PaymentLinkPromo
        utmCampaign={PaymentLinkUtm.Campaign.LINK}
        utmMedium={PaymentLinkUtm.Medium.Completed}
      />
    </>
  );
};
